module.exports = __webpack_public_path__ + "static/media/cantaloupe.777ccc97.jpg";